import { useMemo } from 'react'

import { useQueuesQuery } from 'modules/api/queues/queries'
import { UrlStateStorageKeys } from 'modules/url-state-storage/consts'
import { useHashedSearchParams } from 'modules/url-state-storage/useHashedSearchParams'
import { GlobalFilterState } from 'pages/Monitoring/GlobalFilters/GlobalFilters'
import { UUID } from 'types'

import { useChannel } from './useChannel'

export const useQueueIdsFilteredBySpecialisation = (specialisationId?: UUID) => {
  const { channel, regionedChannel } = useChannel()
  const { data: queues } = useQueuesQuery({ channel })

  const { state } = useHashedSearchParams<GlobalFilterState>({
    hashParamKey: UrlStateStorageKeys.GlobalFilters,
    contextKey: regionedChannel,
  })

  const queueIds = state.queues ?? []

  const queueMap = useMemo(
    () =>
      queues && specialisationId
        ? new Map(queues?.map(queue => [queue.id, queue]))
        : null,
    [specialisationId, queues],
  )

  if (!specialisationId) {
    return queueIds
  }

  if (!queueMap) {
    return undefined
  }

  return queueIds.filter(
    queueId => queueMap.get(queueId)?.specialisationId === specialisationId,
  )
}
